import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=ebe9c37e"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=ebe9c37e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports